var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLinkedIn = function SvgLinkedIn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 14,
    fill: "#fff",
    "aria-label": "LinkedIn Logo"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.714 4.485H.754v9.12h2.96zM10.905 4.485c-1.693 0-2.162.52-2.539 1.19v-1.19h-2.96v9.12h2.96V8.45c0-.793 0-1.586 1.48-1.586s1.48.793 1.48 1.586v5.154h2.961V8.45c0-2.379-.423-3.965-3.382-3.965M2.234 3.692c.818 0 1.48-.621 1.48-1.387 0-.767-.662-1.388-1.48-1.388-.817 0-1.48.621-1.48 1.388s.663 1.387 1.48 1.387"
  })));
};
export default SvgLinkedIn;